import { Component } from '@angular/core';
import { UploadFilesService } from '../../services/upload-files.service';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-upload-files-details',
  templateUrl: './upload-files-details.component.html',
})
export class UploadFilesDetailsComponent {
  // Stores selected files keyed by type
  files: { [key: string]: File } = {};

  // Stores uploaded files for preview (Mocked Data)
  // uploadedFiles: { [key: string]: { name: string; url: string } } = {};

  uploadedFiles: { [key: string]: { name: string; url: string }[] } = {};
  modifiedFiles: { [key: string]: File[] } = {};
// Stores uploaded files for preview (Mocked Data)
//   // Error message for validation or upload issues
  errorMessage: string = '';

  constructor(
    private fileUploadService: UploadFilesService,
    private authservice: AuthenticationService,
    private cd: ChangeDetectorRef // Inject ChangeDetectorRef
  ) {}
  public user_details: any = this.authservice.getUserDetails();

  /**
   * Handles file selection and stores the file based on its type.
   * Validates file type and size.
   * @param event File input change event
   * @param fileType The type of file (e.g., aadharCard, panCard)
   */
  ngOnInit() {
    this.checkExistingFiles();
  }

  // Check if Aadhar Card file exists on the server
  checkExistingFiles() {
    this.fileUploadService.getUserFiles(this.user_details?.user_id).subscribe(
      (response: any) => {
        if (response.success && response.files) {
          this.uploadedFiles = response.files; // Set existing files
        }
      },
      (error) => {
        console.error('Error fetching existing files:', error);
      }
    );
  }
  onFileChange(event: Event, fileType: string): void {
    const input = event.target as HTMLInputElement;
  
    if (input.files && input.files.length > 0) {
      const file: File = input.files[0]; // For single file uploads
      const allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
      const maxSize = 5 * 1024 * 1024; // 5 MB
  
      const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
  
      if (!allowedExtensions.includes(fileExtension)) {
        this.errorMessage = `Invalid file type for ${fileType}: Only pdf, jpg, jpeg, and png are allowed.`;
        return;
      }
  
      if (file.size > maxSize) {
        this.errorMessage = `File size exceeds 5MB for ${fileType}: ${file.name}`;
        return;
      }
  
      this.errorMessage = '';
  
      // Update uploadedFiles with the single file
      this.uploadedFiles[fileType] = [
        {
          name: file.name,
          url: URL.createObjectURL(file),
        },
      ];
  
      // Mark the file as modified for submission
      this.modifiedFiles[fileType] = [file];
    }
  }
  
  // onFileChange(event: Event, fileType: string): void {
  //   const input = event.target as HTMLInputElement;
  
  //   if (input.files && input.files.length > 0) {
  //     const file: File = input.files[0];
  //     const allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
  //     const maxSize = 5 * 1024 * 1024; // 5 MB
  
  //     const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
  
  //     if (!allowedExtensions.includes(fileExtension)) {
  //       this.errorMessage = `Invalid file type for ${fileType}: Only pdf, jpg, jpeg, and png are allowed.`;
  //       return;
  //     }
  
  //     if (file.size > maxSize) {
  //       this.errorMessage = `File size exceeds 5MB for ${fileType}: ${file.name}`;
  //       return;
  //     }
  
  //     this.errorMessage = '';
  
  //     // Initialize `uploadedFiles[fileType]` as an array if not already
  //     if (!Array.isArray(this.uploadedFiles[fileType])) {
  //       this.uploadedFiles[fileType] = [];
  //     }
  
  //     // Replace the existing file for single-file uploads
  //     this.uploadedFiles[fileType] = [
  //       {
  //         name: file.name,
  //         url: URL.createObjectURL(file),
  //         file,
  //       },
  //     ];
  //   }
  // }  
  
  // onSalaryStatementsChange(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  
  //   if (input.files && input.files.length > 0) {
  //     // Initialize `uploadedFiles['6']` as an array if not already
  //     if (!Array.isArray(this.uploadedFiles['6'])) {
  //       this.uploadedFiles['6'] = [];
  //     }
  
  //     const allowedExtensions = ['png', 'jpg', 'jpeg'];
  //     const maxSize = 5 * 1024 * 1024; // 5 MB
  
  //     Array.from(input.files).forEach((file) => {
  //       const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
  
  //       if (!allowedExtensions.includes(fileExtension)) {
  //         this.errorMessage = `Invalid file type: Only png, jpg, and jpeg are allowed.`;
  //         return;
  //       }
  
  //       if (file.size > maxSize) {
  //         this.errorMessage = `File size exceeds 5MB: ${file.name}`;
  //         return;
  //       }
  
  //       // if (this.uploadedFiles['6'].length > 3) {
  //       //   this.errorMessage = `You can upload a maximum of 3 files for Salary Statements.`;
  //       //   return;
  //       // }
  
  //       this.errorMessage = ''; // Clear any previous errors
  
  //       // Add the file to the Salary Statements array
  //       this.uploadedFiles['6'].push({
  //         name: file.name,
  //         url: URL.createObjectURL(file), // Temporary URL for preview
  //         file, // Actual file object
  //       });
  //     });
  //   }
  // }
  
  
  // onSubmit(): void {
  //   const requiredFields = ['1', '2']; // Aadhar (1) and PAN (2) are mandatory
  //   const allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
  //   const maxSize = 5 * 1024 * 1024; // 5 MB
  //   const formData = new FormData();
  
  //   // Validate required fields
  //   const missingFields = requiredFields.filter(
  //     (field) => !this.uploadedFiles[field] || this.uploadedFiles[field].length === 0
  //   );
  
  //   if (missingFields.length > 0) {
  //     this.errorMessage = `Please upload the required (*) files.`;
  //     return;
  //   }
  
  //   // Append all files to FormData
  //   for (const fileType in this.uploadedFiles) {
  //     const files = this.uploadedFiles[fileType];
  
  //     if (!Array.isArray(files)) {
  //       console.error(`Expected an array for fileType ${fileType}, but got`, files);
  //       continue;
  //     }
  
  //     files.forEach((fileData, index) => {
  //       const { file, name } = fileData;
  //       const fileExtension = name.split('.').pop()?.toLowerCase() || '';
  
  //       if (!allowedExtensions.includes(fileExtension)) {
  //         this.errorMessage = `Invalid file type for ${fileType}: ${name}`;
  //         return;
  //       }
  
  //       if (file.size > maxSize) {
  //         this.errorMessage = `File size exceeds 5MB for ${fileType}: ${name}`;
  //         return;
  //       }
  
  //       formData.append(fileType === '6' ? `${fileType}[${index}]` : fileType, file, name);
  //     });
  //   }
  
  //   const userId = this.user_details?.user_id;
  //   const username = this.user_details?.username;
  
  //   if (!userId) {
  //     this.errorMessage = `User ID is missing. Please ensure you are logged in.`;
  //     return;
  //   }
  
  //   formData.append('user_id', userId);
  //   formData.append('user_name', username);
  
  //   this.errorMessage = '';
  
  //   // Use your file upload service
  //   this.fileUploadService.uploadFiles(formData).subscribe({
  //     next: (response: any) => {
  //       alert('Files uploaded successfully.');
  //       this.uploadedFiles = response?.uploadedFiles || {};
  //     },
  //     error: (err) => {
  //       this.errorMessage = `File upload failed: ${
  //         err?.error?.message || err.message || 'Unknown error'
  //       }`;
  //       console.error('Error:', err);
  //     },
  //   });
  // }
  
// Handles single-file uploads
// onFileChange(event: Event, fileType: string): void {
//   const input = event.target as HTMLInputElement;

//   if (input.files && input.files.length > 0) {
//     const file: File = input.files[0];
//     const allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
//     const maxSize = 5 * 1024 * 1024; // 5 MB

//     const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';

//     if (!allowedExtensions.includes(fileExtension)) {
//       this.errorMessage = `Invalid file type for ${fileType}: Only pdf, jpg, jpeg, and png are allowed.`;
//       return;
//     }

//     if (file.size > maxSize) {
//       this.errorMessage = `File size exceeds 5MB for ${fileType}: ${file.name}`;
//       return;
//     }

//     this.errorMessage = '';

//     // Update uploaded files for preview
//     this.uploadedFiles[fileType] = [
//       {
//         name: file.name,
//         url: URL.createObjectURL(file),
//       },
//     ];

//     // Mark the file as modified
//     this.modifiedFiles[fileType] = [file];
//   }
// }

// Handles multi-file uploads for Salary Statements
onSalaryStatementsChange(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (input.files && input.files.length > 0) {
    const allowedExtensions = ['png', 'jpg', 'jpeg'];
    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (!Array.isArray(this.uploadedFiles['6'])) {
      this.uploadedFiles['6'] = [];
    }

    if (!Array.isArray(this.modifiedFiles['6'])) {
      this.modifiedFiles['6'] = [];
    }

    Array.from(input.files).forEach((file) => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';

      if (!allowedExtensions.includes(fileExtension)) {
        this.errorMessage = `Invalid file type: Only png, jpg, and jpeg are allowed.`;
        return;
      }

      if (file.size > maxSize) {
        this.errorMessage = `File size exceeds 5MB: ${file.name}`;
        return;
      }

      this.errorMessage = '';

      // Update uploaded files for preview
      this.uploadedFiles['6'].push({
        name: file.name,
        url: URL.createObjectURL(file),
      });

      // Mark the file as modified
      this.modifiedFiles['6'].push(file);
    });
  }
}
isLoading: boolean = false;
loadUserFiles(userId: string): void {
  this.isLoading = true;
  this.fileUploadService.getUserFiles(userId).subscribe({
    next: (response: any) => {
      console.log('Fetched user files:', response);
      this.uploadedFiles = response?.files || {};
      this.modifiedFiles = {};
      this.isLoading = false;
      this.cd.detectChanges();
    },
    error: (err: any) => {
      console.error('Failed to load user files:', err);
      this.isLoading = false;
    },
  });
}


// Submit only modified files
onSubmit(): void {
  const formData = new FormData();
if (!this.modifiedFiles || Object.keys(this.modifiedFiles).length === 0) {
    this.errorMessage = `No files selected for upload. Please select files to proceed.`;
    return;
  }
  // Mandatory file types
  const mandatoryFileTypes = ['7', '1', '2'];

  for (const fileType of mandatoryFileTypes) {
    // Check if files for this fileType are already uploaded or newly modified
    const existingFiles = this.uploadedFiles?.[fileType] || []; // Assume uploadedFiles is populated by checkExistingFiles()
    const newFiles = this.modifiedFiles?.[fileType] || [];
    
    if (existingFiles.length === 0 && newFiles.length === 0) {
      this.errorMessage = `* Marked Files are required. Please upload the missing files`;
      return;
    }
  }
  // Add only modified files to FormData
  for (const fileType in this.modifiedFiles) {
    const files = this.modifiedFiles[fileType];
    files.forEach((file, index) => {
      formData.append(fileType === '6' ? `${fileType}[${index}]` : fileType, file, file.name);
    });
  }

  const userId = this.user_details?.user_id;
  const username = this.user_details?.username;

  if (!userId) {
    this.errorMessage = `User ID is missing. Please ensure you are logged in.`;
    return;
  }

  formData.append('user_id', userId);
  formData.append('user_name', username);

  this.errorMessage = '';

  // Debug log for submission
  console.log('Submitting form data:', formData);

  this.fileUploadService.uploadFiles(formData).subscribe({
    next: (response: any) => {
      alert('Files uploaded successfully.');

      // Debug log for successful upload
      console.log('Upload response:', response);

      // Introduce a delay to ensure backend processing
      setTimeout(() => {
        console.log('Reloading user files...');
        this.loadUserFiles(userId); // Reload updated files
      }, 1000); // 1-second delay
    },
    error: (err) => {
      this.errorMessage = `File upload failed: ${
        err?.error?.message || err.message || 'Unknown error'
      }`;
      console.error('Error:', err);
    },
  });
}

}
